import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { InformationTextCont } from './NewPasswordConfirm.styles';
import { RouteNames } from '../../../../constans/routes';
import InformationText from '../../../InformationText/InformationText';
import ResetPassword from '../../ResetPassword';
import { Headline, HeadlineBold } from '../../ResetPassword.styles';

interface INewPasswordConfirm {
  isSuccessful: boolean;
}

const NewPasswordConfirm: FC<INewPasswordConfirm> = ({ isSuccessful }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const headline = (
    <Headline data-testid="new-password-confirm-headline">
      <HeadlineBold>{t('login.newPassword.password')}&nbsp;</HeadlineBold>
      {isSuccessful
        ? t('login.newPassword.resetSuccessful')
        : t('login.newPassword.resetUnsuccessful')}
    </Headline>
  );

  const resetPasswordConfirm = (
    <InformationTextCont data-testid="new-password-confirm">
      <InformationText
        text={
          isSuccessful
            ? t('login.newPassword.successConfirmText')
            : t('login.newPassword.unsuccessConfirmText')
        }
      />
    </InformationTextCont>
  );

  return (
    <ResetPassword
      headline={headline}
      content={resetPasswordConfirm}
      submit={() =>
        isSuccessful ? navigate(RouteNames.Login) : navigate(RouteNames.PasswordReset)
      }
      buttonText={
        isSuccessful ? t('login.newPassword.login') : t('login.newPassword.resetMyPassword')
      }
    />
  );
};

export default NewPasswordConfirm;
